import { useEffect, useRef, useState } from "react";

// Fires once when the element scrolls into view. Used to trigger the
// leaf-rib underline draw and the section reveal fade — both are inert
// (already "visible") when prefers-reduced-motion is set, since the CSS
// guards handle that; this hook just toggles the class.
const useReveal = (threshold = 0.2) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  return [ref, isVisible];
};

export default useReveal;
